import React, { useState } from "react";
import { motion } from "framer-motion";

const Books = () => {
  const [activeTab, setActiveTab] = useState("read");

  const bookData = {
    // Daftar Buku yang Sudah Selesai Dibaca (Finished)
    read: [
      { title: "Wedding Agreement", author: "Mia Chuz", genre: "Romance", review: "Cerita yang sangat menyentuh hati. ✨", poster: "/posters/weddingagreement.jpg" },
      { title: "Geez & Ann", author: "Rintik Sedu", genre: "Romance", review: "Tentang arti melepaskan. 🍂", poster: "/posters/geez.jpg" },
      { title: "Tentang Kamu", author: "Tere Liye", genre: "Drama", review: "Perjalanan hidup yang luar biasa. ✈️", poster: "/posters/tentangkamu.jpg" },
      { title: "Teruslah Bodoh Jangan Pintar", author: "Tere Liye", genre: "Self-Dev", review: "Sudut pandang yang sangat menarik. 💡", poster: "/posters/tbjp.jpg" },
      { title: "Hujan", author: "Tere Liye", genre: "Sci-Fi Romance", review: "Tentang melupakan dan memori. 🌧️", poster: "/posters/Hujan.jpg" },
      { title: "Pribadi Hebat", author: "Hamka", genre: "Philosophy", review: "Membangun jiwa yang kuat. 🏛️", poster: "/posters/pribadihebat.jpg" },
      { title: "Tenggelamnya Kapal Van Der Wijck", author: "Hamka", genre: "Classic", review: "Kisah cinta legendaris. 🚢", poster: "/posters/kapal.jpg" },
      { title: "Things Left Behind", author: "Kim Sae Byoul", genre: "Essay", review: "Menghargai apa yang tersisa. 🎒", poster: "/posters/things.jpg" },
      { title: "Laut Bercerita", author: "Leila S. Chudori", genre: "History", review: "Laut yang abadi, hiduplah berkali-kali.", poster: "/posters/laut.jpg" },
      { title: "Perempuan yang Menangis Kepada Bulan Hitam", author: "Dian Purnomo", genre: "Survival", review: "Hidup perempuan yang melawan!.", poster: "/posters/bulanhitam.jpg" },
      { title: "Bersauh", author: "Amellidong", genre: "Love", review: "When you pretend to avoid your feeling in the same time you fallin'.", poster: "/posters/bersauh.jpg" },
      { title: "It Ends With Us", author: "Colleen Hoover", genre: "Love", review: "Run, Lily.", poster: "/posters/end.jpg" },
    ],

    // Daftar Buku yang Akan Dibaca (To Read)
    wishlist: [
      { title: "Bumi Manusia", author: "Pramoedya Ananta Toer", genre: "Classic", status: "Must read! 🌏", poster: "/posters/bumi.jpg" },
      { title: "Jejak Langkah", author: "Pramoedya Ananta Toer", genre: "Classic", status: "Waiting on shelf 👣", poster: "/posters/jejaklangkah.jpg" },
      { title: "Anak Semua Bangsa", author: "Pramoedya Ananta Toer", genre: "Classic", status: "Historical journey 🏛️", poster: "/posters/anaksemuabangsa.jpg" },
      { title: "Efek Rumah Kaca", author: "Pramoedya Ananta Toer", genre: "Classic", status: "The final series 🔍", poster: "/posters/rumahkaca.jpg" },
      { title: "As Long as Lemon Trees Grow", author: "Zoulfa Katouh", genre: "Fiction", status: "Heartbreakingly beautiful 🍋", poster: "/posters/lemon.jpeg" },
      { title: "1984", author: "George Orwell", genre: "Dystopian", status: "Classic masterpiece 👁️", poster: "/posters/1984.jpg" },
      { title: "Janji", author: "Tere Liye", genre: "Drama", status: "Soon to be read 🤝", poster: "/posters/janji.jpeg" },
      { title: "Hello", author: "Tere Liye", genre: "Romance", status: "On my radar 👋", poster: "/posters/hello.jpg" },
    ]
  };

  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="category-header">
        <h2 className="main-title">Stories That Shaped Me 📚</h2>
        
        <div className="tab-menu">
          <button 
            className={activeTab === "read" ? "active" : ""} 
            onClick={() => setActiveTab("read")}
          >
            Finished ({bookData.read.length})
          </button>
          <button 
            className={activeTab === "wishlist" ? "active" : ""} 
            onClick={() => setActiveTab("wishlist")}
          >
            To Read ({bookData.wishlist.length})
          </button>
        </div>
      </div>

      <div className="film-grid">
        {bookData[activeTab].map((book, i) => (
          <motion.div 
            key={i} 
            className="film-card-visual"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.05 }}
            whileHover={{ y: -10 }}
          >
            <div className="poster-wrapper">
              <img 
                src={book.poster} 
                alt={book.title} 
                onError={(e) => {e.target.src = "https://via.placeholder.com/200x300?text=No+Cover"}} 
              />
            </div>
            <div className="film-details">
              <h4>{book.title}</h4>
              <span className="film-meta">{book.author} • {book.genre}</span>
              <p className="film-desc">{book.review || book.status}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Books;